// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfj_a bhi_wh bhi_sq bhi_xj"};